export * from '@taqueria/protocol/out/types/ConfigEnvironmentFileV2';
